<template>
  <div class="col-lg-8 offset-lg-2 page">
    <div class="row">
      <vaccination-filter :arrayToFilter="allVaccinations" :type="type"
                          v-on:update-keywords="updateKeywords"
                          v-on:filter-vaccinations="updateFilterResults">

      </vaccination-filter>

      <vaccination-sort :arrayToSort="filteredVaccinations
                        ? filteredVaccinations : allVaccinations"
                        v-on:sortArray="updateSortedResults">

      </vaccination-sort>
    </div>

    <vaccination-detail :keywords="keywords"
                        :vaccinations="filteredVaccinations
                        ? filteredVaccinations : allVaccinations">

    </vaccination-detail>
  </div>
</template>

<script>
  import FilterPage from '../_partials/filter/FilterPage';
  import SortPage from '../_partials/sort/SortPage';
  import VaccinationDetail from './VaccinationDetail';
  import {mapGetters} from 'vuex';
  import {getAllVaccinations} from '@/data/getters.js';

  export default {
    name: "VaccinationPage",
    components: {
      'vaccination-filter': FilterPage,
      'vaccination-sort': SortPage,
      'vaccination-detail': VaccinationDetail,
    },
    data() {
      return {
        filteredVaccinations: null,
        keywords: [],
        type: 'VACCINATION',
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      }),
      allVaccinations: function () {
        return getAllVaccinations(this.allData);
      }
    },
    methods: {
      updateKeywords(data) {
        this.keywords = data;
      },
      updateFilterResults(data) {
        this.filteredVaccinations = data;
      },
      updateSortedResults(data) {
        this.filteredVaccinations = data;
      }
    }
  }
</script>

<style scoped lang="scss">
  .page {
    max-width: 800px;
  }
</style>